<template>
  <!-- begin:: Footer -->
  <div class="footer py-4">
    <!--begin::Container-->
    <div>
      <!--begin::Copyright-->
      <div class="text-dark d-flex flex-wrap justify-content-center">
        <div class="text-muted font-weight-bold pr-1" id="year">©{{ new Date().getFullYear() }}</div>
        <div class="pr-2">Tell Me Genius</div>
        <div class="px-4"><Cgu/> </div>
        <div class="pl-2"><a href="https://www.insaniam.fr/" target="_blank" class="text-dark-75 text-hover-primary">{{$t('common.footer')}}</a></div>
      </div>
      <!--end::Copyright-->
      <!--begin::Nav-->
      <!-- <div class="nav nav-dark order-1 order-md-2">
        <a
          href="http://keenthemes.com/metronic"
          target="_blank"
          class="nav-link pr-3 pl-0"
          >About</a
        >
        <a
          href="http://keenthemes.com/metronic"
          target="_blank"
          class="nav-link px-3"
          >Team</a
        >
        <a
          href="http://keenthemes.com/metronic"
          target="_blank"
          class="nav-link pl-3 pr-0"
          >Contact</a
        >
      </div> -->
      <!--end::Nav-->
    </div>
    <!--end::Container-->
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";
import Cgu from "@/components/common/cgu";

export default {
  name: "KTFooter",
  components: { Cgu },
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    }
  }
};
</script>
